import GenericApi from "./GenericApi";

class AccountApi extends GenericApi {

    tokenName = "_s"

    static isThirdPartSsoBindValid(params) {
        return this.getJson("/account/bind/valid", params, {
            headers: {
                __remember: "true",
                'Content-Type': 'application/json',
            }
        })
    }

    static unBindSso(params) {
        return this.getJson(`/account/unbind`, params, {
            headers: {
                __remember: "true",
                'Content-Type': 'application/json',
            }
        })
    }

    static updateUserInfo(userInfo) {
        return this.putJson("/account/member/user_info", userInfo, {
            headers: {
                __remember: "true",
                'Content-Type': 'application/json',
            }
        })
    }

    static updatePassword(name, password, oldPassword) {
        return this.putJson("/account/member/password", {
            name: name.trim(),
            password: password.trim(),
            oldPassword: oldPassword.trim()
        }, {
            headers: {
                __remember: "true",
                'Content-Type': 'application/json',
            }
        })
    }

    static resetPassword(name, passwordNew, sessionId, validateCode) {
        return this.putJson(`/account/member/mobile/password?sessionId=${sessionId}&validateCode=${validateCode?.trim()}`, {
            name: name?.trim(),
            password: passwordNew?.trim(),
        }, {
            headers: {
                __remember: "true",
                'Content-Type': 'application/json',
            }
        })
    }

    static sendVerifyCode(phone, data, exists, notbind) {
        return this.postJson(`/account/sms/send/tencent?phone=${phone}&exists=${exists}&notbind=${notbind}`, data, {
            headers: {
                __remember: "true",
                'Content-Type': 'application/json',
            }
        })
    }

    static bindPhone(phone, sessionId, validateCode) {
        return this.getJson(`/account/member/mobile/bind?phone=${phone?.trim()}&sessionId=${sessionId}&validateCode=${validateCode?.trim()}`, {}, {
            headers: {
                __remember: "true",
                'Content-Type': 'application/json',
            }
        })
    }

    static bindPhoneRemove() {
        return this.getJson(`/account/member/mobile/bind`, {}, {
            headers: {
                __remember: "true",
                'Content-Type': 'application/json',
            }
        })
    }
}

export default AccountApi;